import { TradingCompetition } from '@flipster/apis/v1/tradingCompetition/types';
import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { divider, hstack, stack } from '@flipster/styled-system/patterns';
import { UsdtPrecision } from '@flipster/utils/constants/currency';
import { numberFormatter } from '@flipster/utils/num';

interface Props {
  champion: NonNullable<TradingCompetition['recurringLastWeekChampion']>;
}

export const LastWeekChampionView = ({ champion }: Props) => {
  return (
    <div
      className={stack({
        gap: 16,
        mx: { base: 16, tablet: 'auto' },
        my: { base: 40, tablet: 80 },
        tablet: { maxW: 'desktopMaxWidth', px: 16, boxSizing: 'content-box' },
      })}
    >
      <p className={css({ textStyle: 'Title/S', color: 'content.default.level-5' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Last_week_s_champion' />
      </p>
      <div
        className={hstack({
          gap: { base: 8, tablet: 12 },
          rounded: 8,
          bg: 'background.default.level-1',
          p: 16,
          alignItems: 'stretch',
          tabletDown: { flexDirection: 'column' },
        })}
      >
        <div className={css({ textStyle: 'Text/M/Strong', color: 'content.default.level-5' })}>{champion.nickname}</div>
        <hr
          className={divider({
            orientation: 'vertical',
            color: 'border.default.level-1',
            h: 'inherit',
            tabletDown: { display: 'none' },
          })}
        />
        <div
          className={hstack({
            gap: { base: 2, tablet: 4 },
            tabletDown: { flexDirection: 'column', alignItems: 'flex-start' },
          })}
        >
          <p className={css({ textStyle: 'Text/S/Regular', color: 'content.default.level-1' })}>
            <FormattedMessage id='Autogen_common.r251126.s_Prize_won' />
          </p>
          <p className={css({ textStyle: 'Text/M/Monospace/Strong', color: 'content.default.level-5' })}>
            {numberFormatter(champion.prize, { precision: UsdtPrecision, toFixed: true })} USDT
          </p>
        </div>
      </div>
    </div>
  );
};
